export default "__VITE_ASSET__DHhKxR1R__"